import apiClient from "../utils/apiClient";

export const getCodigoPaisesLada = async () => {
    try {
      const response = await apiClient.get(`/paisLada`);    
      return response?.data;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  };

export const getLastStatement = async (idReserva) => {
  try {
    const response = await apiClient.get(`/last_statement/${idReserva}`);
    return response?.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
}

export const validarToken = async (idReserva, token) => {
  try {
    const response = await apiClient.get(`/last_statement`, idReserva, token);
    return response?.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
}

export const getActivePDP = async () => {
  try {
    const response = await apiClient.get(`/pasarela/activa`);    
    return response?.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};